import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { ShieldCheck } from 'lucide-react';

interface PaywallDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export function PaywallDialog({ open, onOpenChange }: PaywallDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md bg-card">
        <DialogHeader>
          <div className="mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900 mb-4">
            <ShieldCheck className="h-6 w-6 text-amber-600 dark:text-amber-300" />
          </div>
          <DialogTitle className="text-center">Premium Feature Access</DialogTitle>
          <DialogDescription className="text-center pt-2">
            This feature requires an upgraded subscription plan. Contact your account manager to access all platform features.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex justify-center sm:justify-center gap-2 mt-4">
          <Button 
            variant="outline" 
            onClick={() => onOpenChange(false)}
          >
            Close
          </Button>
          <Button 
            onClick={() => {
              window.open('https://deiterate.com/contact/', '_blank');
              onOpenChange(false);
            }}
          >
            Contact Us
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
